// 增值相关

export default [
  {
    path: '/thunder/singGift',
    component: () => import('@/views/gift/sing_gift.vue'),
    name: 'singGift',
    meta: {
      title: '演唱礼物',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/blessv1',
    name: 'blessv1',
    component: () => import('@/views/bless/bless_v1.vue'),
    meta: {
      title: '霸屏祝福',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/bless_sort/:id',
    name: 'bless_sort',
    component: () => import('@/views/bless/bless_new.vue'),
    meta: {
      title: '霸屏祝福',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/bless_pag1/:id',
    name: 'bless_pag1',
    component: () => import('@/views/bless/bless_pag1.vue'),
    meta: {
      title: '霸屏祝福',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/pag/add_receiver',
    name: 'pag_add_receiver',
    component: () => import('@/views/bless/add_receiver.vue'),
    meta: {
      title: '添加接收人',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/adopt',
    name: 'adopt',
    component: () => import('@/views/MVP/index.vue'),
    meta: {
      title: '歌曲冠名',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/adopt_song',
    name: 'adopt',
    component: () => import('@/views/MVP/adopt.vue'),
    meta: {
      title: '冠名歌曲',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/my_adopt',
    name: 'adopt',
    component: () => import('@/views/MVP/mine.vue'),
    meta: {
      title: '我的冠名',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/photo',
    name: 'photo',
    component: () => import('@/views/photo/photo'),
    meta: {
      title: '照片祝福',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/photov2',
    name: 'photov2',
    component: () => import('@/views/photo/photo_v2'),
    meta: {
      title: '照片祝福',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/photo_pag1',
    name: 'photo_pag1',
    component: () => import('@/views/photo/photo_pag1'),
    meta: {
      title: '照片祝福',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/photo_doutu',
    name: 'photo_doutu',
    component: () => import('@/views/photo/photo_doutu'),
    meta: {
      title: '大屏斗图',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/photov2_doutu',
    name: 'photov2_doutu',
    component: () => import('@/views/photo/photo_v2_doutu'),
    meta: {
      title: '大屏斗图',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/send_success/:type',
    name: 'send_success',
    component: () => import('@/views/send_success/send_success.vue'),
    meta: {
      title: '发送成功',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/charge',
    name: 'charge',
    redirect: '/thunder/home',
  },
  {
    path: '/thunder/vip_success',
    name: 'vipSuccess',
    component: () => import('@/views/vip/vip_success.vue'),
    meta: {
      title: 'VIP开通成功',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/openvip',
    name: 'vip',
    component: () => import('@/views/vip/open_vip.vue'),
    meta: {
      title: '开通会员',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/givevip',
    name: 'vipGivevip',
    component: () => import('@/views/activity/present-vip/give-friend.vue'),
    meta: {
      title: '赠送VIP',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/presentvip',
    name: 'vipPresentvip',
    component: () => import('@/views/activity/present-vip/index.vue'),
    meta: {
      title: '赠送VIP',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/vip_rights/:id',
    name: 'vipRights',
    component: () => import('@/views/vip/vip_rights.vue'),
    meta: {
      title: '特权说明',
    },
  },
  {
    path: '/thunder/openvip/plus',
    name: 'vipPlus',
    component: () => import('@/views/vip/vip_plus.vue'),
    meta: {
      title: 'plus特权',
    },
  },
  {
    path: '/thunder/expression',
    name: 'expression',
    component: () => import('@/views/expression/expression.vue'),
    meta: {
      title: '聊骚表情',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/appmusic',
    name: 'appmusic',
    component: () => import('@/views/appmusic/appmusic'),
    meta: {
      title: '导入歌单',
    },
  },
  {
    path: '/thunder/mv',
    name: 'mv',
    component: () => import('@/views/mv/mv_v3'),
    meta: {
      title: '照片MV',
    },
  },
  {
    path: '/thunder/blessing_song',
    component: () => import('@/views/bless/bless_song.vue'),
    name: 'blessingSong',
    meta: {
      title: '祝福点歌',
    },
  },
  {
    path: '/thunder/gift',
    component: () => import('@/views/gift/gift.vue'),
    name: 'gift',
    meta: {
      title: '大屏送礼物',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/gift_pag',
    component: () => import('@/views/gift/gift.vue'),
    name: 'gift',
    meta: {
      title: '大屏送礼物',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/opening_effect',
    component: () => import('@/views/opening_effect/index.vue'),
    name: 'opening_effect',
    meta: {
      title: '歌神点歌',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/opening_pag_effect',
    component: () => import('@/views/opening_pag_effect/index.vue'),
    name: 'opening_pag_effect',
    meta: {
      title: '歌神点歌',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/gift_free',
    component: () => import('@/views/gift/gift_free_action.vue'),
    name: 'giftFree',
    meta: {
      title: '大屏送礼物',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/spoof',
    component: () => import('@/views/gift/gift_spoof.vue'),
    name: 'giftSpoof',
    meta: {
      title: '恶搞整蛊',
      notShowOrderList: true,
    },
  },
  // 上传
  {
    path: '/thunder/send_video',
    component: () => import('@/views/send_video/send_video.vue'),
    name: 'send_video',
    meta: {
      title: '发视频',
    },
  },
  {
    path: '/thunder/disco_party',
    component: () => import('@/views/disco/party.vue'),
    name: 'discoParty',
    meta: {
      title: '蹦迪派对',
      notShowOrderList: true,
      level: 1,
    },
  },
  {
    path: '/thunder/disco',
    component: () => import('@/views/disco/index.vue'),
    name: 'disco',
    meta: {
      title: '蹦迪模式',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/equity_vip',
    component: () => import('@/views/equity_vip/index.vue'),
    name: 'equity_vip',
    meta: {
      title: '会员中心',
      notShowOrderList: true,
      level: 1,
    },
  },
];
